import { createContext } from 'react';

import type { ToastContainer } from '@cognite/cogs-lab-v11';
import type { ConfigProvider } from '@cognite/cogs.js-v11';
import type { SDKProvider } from '@cognite/sdk-provider';

import type { AccessProvider } from './access-provider/access-provider';
import type { AppConfigFiltersProvider } from './app-config-filters-provider/app-config-filters-provider';
import type { BackButtonUrlProvider } from './back-button-url-provider/back-button-url-provider';
import type { CurrentUserProvider } from './current-user-provider/current-user-provider';
import type { FDMServicesProvider } from './fdm-services/fdm-services-provider';
import type { AppConfigProvider } from './is-idm-provider/app-config-provider';
import type { NetworkStatusProvider } from './network-status-provider/network-status-provider';
import type { PersistQueryFunctionsProvider } from './persist-query-functions-provider/persist-query-functions-provider';
import type { UserOnboardingProvider } from './user-onboarding-provider/user-onboarding-provider';

export interface ClassicProvidersContextInterface {
  AppConfigProvider: typeof AppConfigProvider;
  ConfigProvider: typeof ConfigProvider;
  ToastContainer: typeof ToastContainer;
  FDMServicesProvider: typeof FDMServicesProvider;
  BackButtonUrlProvider: typeof BackButtonUrlProvider;
  NetworkStatusProvider: typeof NetworkStatusProvider;
  CurrentUserProvider: typeof CurrentUserProvider;
  UserOnboardingProvider: typeof UserOnboardingProvider;
  AppConfigFiltersProvider: typeof AppConfigFiltersProvider;
  PersistQueryFunctionsProvider: typeof PersistQueryFunctionsProvider;
  SDKProvider: typeof SDKProvider;
  AccessProvider: typeof AccessProvider;
}

export const ClassicProvidersContext =
  createContext<ClassicProvidersContextInterface | null>(null);
